import PropTypes from "prop-types";
import SourceFlow from "@/assets/sourceflow.svg";

export default function SiteFooterBy({ className }) {
  return (
    <div className={className}>
      <span>Website by </span>
      <SourceFlow />

    </div>
  );
}

SiteFooterBy.defaultProps = {
  className: "",
};

SiteFooterBy.propTypes = {
  className: PropTypes.string,
};
